export interface ProjectListItem {
  id: string;
  name: string;
  propertyTypeId: string | null;
  generalValue: string | null;
  logoUrl: string | null;
  isActive: boolean;
  createdAt: string;
}

export interface ProjectBlueprintSummary {
  id: string;
  name: string;
  previewDataUrl: string | null;
  updatedAt: string;
}

export interface ProjectPartnerSummary {
  id: string;
  firstName: string;
  lastName: string;
  percentage: number;
}

export interface ProjectPartnerShareInput {
  partnerId: string;
  percentage: number;
}

export interface ProjectDetail {
  id: string;
  name: string;
  purchaseDate: string | null;
  address: string | null;
  propertyTypeId: string | null;
  quantity: number | null;
  location: string | null;
  vereda: string | null;
  municipality: string | null;
  department: string | null;
  country: string | null;
  predioMatriculaNumber: string | null;
  predioCatastralReference: string | null;
  predioCurrentName: string | null;
  predioAreaHectares: string | null;
  predioAreaM2: string | null;
  predioBoundaries: string | null;
  currentOwnersText: string | null;
  partners: ProjectPartnerSummary[];
  generalValue: string | null;
  paymentTypeId: string | null;
  logoUrl: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  blueprint: ProjectBlueprintSummary | null;
  soldLotsTotal: string;
  utility: string;
}

export interface PaginatedProjects {
  items: ProjectListItem[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface ProjectFilters {
  page?: number;
  limit?: number;
  search?: string;
  /** Inclusive `purchaseDate` range, 'YYYY-MM-DD'. */
  dateFrom?: string;
  dateTo?: string;
}

export interface ProjectCreateRequest {
  name: string;
  purchaseDate?: string | null;
  address?: string | null;
  propertyTypeId?: string | null;
  quantity?: number | null;
  location?: string | null;
  vereda?: string | null;
  municipality?: string | null;
  department?: string | null;
  country?: string | null;
  predioMatriculaNumber?: string | null;
  predioCatastralReference?: string | null;
  predioCurrentName?: string | null;
  predioAreaHectares?: string | null;
  predioAreaM2?: string | null;
  predioBoundaries?: string | null;
  currentOwnersText?: string | null;
  partners?: ProjectPartnerShareInput[];
  generalValue?: string | null;
  paymentTypeId?: string | null;
}

export interface ProjectUpdateRequest {
  name?: string;
  purchaseDate?: string | null;
  address?: string | null;
  propertyTypeId?: string | null;
  quantity?: number | null;
  location?: string | null;
  vereda?: string | null;
  municipality?: string | null;
  department?: string | null;
  country?: string | null;
  predioMatriculaNumber?: string | null;
  predioCatastralReference?: string | null;
  predioCurrentName?: string | null;
  predioAreaHectares?: string | null;
  predioAreaM2?: string | null;
  predioBoundaries?: string | null;
  currentOwnersText?: string | null;
  partners?: ProjectPartnerShareInput[];
  generalValue?: string | null;
  paymentTypeId?: string | null;
}

/** What the project form asks to do with the logo once the project itself is saved. */
export type ProjectLogoChange =
  { action: 'keep' } | { action: 'replace'; file: File } | { action: 'remove' };

export const PROJECT_LOGO_ACCEPT = 'image/png,image/jpeg,image/webp';
export const PROJECT_LOGO_MAX_BYTES = 2 * 1024 * 1024;
